export default {
  data: function () {
    return {
      table: {
        rows: [],
        selectedRows: [],
        fields: []
      }
    };
  }
};
